/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import uniq from 'lodash/uniq';
import { APP_DEFAULT_LANGUAGE, TRANSLATIONS_IDS_MAP } from 'config/constants';

import { IBibleState, IBook } from './types';

const NOTES = 'notes';

const defaultTranslationId = TRANSLATIONS_IDS_MAP[APP_DEFAULT_LANGUAGE];
const initialState: IBibleState = {
  translations: [defaultTranslationId],
  book: {
    number: 40,
    chaptersCount: 28,
  },
  chapter: 1,
  verse: 0,
};

const biblesSlice = createSlice({
  name: 'biblesSlice',
  initialState,
  reducers: {
    changeTranslations: (state, { payload }: PayloadAction<(number | string)[]>) => {
      if (payload.length === 1 && payload[0] === NOTES) {
        state.translations = [...payload, defaultTranslationId];
      } else {
        state.translations = payload.length ? payload : [defaultTranslationId];
      }
    },
    addTranslation: (state, action: PayloadAction<number>) => {
      state.translations = uniq([...state.translations, action.payload]);
    },
    setBook: (state, action: PayloadAction<IBook>) => {
      state.book = action.payload;
    },
    setChapter: (state, action: PayloadAction<number>) => {
      state.chapter = action.payload;
    },
    setVerse: (state, action: PayloadAction<number>) => {
      state.verse = action.payload;
    },
    setBibleUrlParams: (state, action: PayloadAction<{ book: IBook; chapter: number; verse: number; translations: (number | string)[] }>) => {
      state.book = action.payload.book;
      state.chapter = action.payload.chapter;
      state.verse = action.payload.verse;
      state.translations = action.payload.translations;
    },
  },
});

export default biblesSlice;
